import GlobeIcon from './GlobeIcon'

export default GlobeIcon
